module.exports = __webpack_public_path__ + "img/lazer2.50e2ba37.svg";